import React from "react";
import FormRow from "../../components/formrow";
import { type GetSetValueProp } from "../models";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

const DisplayPagination = (props: GetSetValueProp<boolean>) => <div className="margin-bottom-mini">

  <FormRow label={RESX.EmbedWizard.Pagination}>
    <Checkbox
      checked={props.value}
      onChange={(_, checked) => { props.setValue(checked); }}
    />
  </FormRow>
</div>;

export default DisplayPagination;